import React from 'react';

import {gettext} from 'topmeteo/utils/i18n';

import TextItem from './TextItem';

const Label = gettext('No results…');

const NoResults = () => <TextItem text={Label} />;

export default NoResults;
